<template>
    <div class="look_work_box">
        <el-table
            :data="tableData"
            border
            style="width: 100%"> 
            <el-table-column
            :width="val.is_img_url ?400:''"
             :prop="val.prop" 
            :label="val.label" v-for="(val,index) in tableTitle" :key="index">
                <template slot-scope="scope">
                    <el-image 
                        v-if="val.is_img"
                        style="width: 100px"
                        :src="scope.row[val.prop]" 
                        :preview-src-list="[scope.row[val.prop]]">
                    </el-image>
                    <div v-else-if="val.is_username">
                        {{scope.row.user_info.username}}
                    </div>
                    <div v-else-if="val.is_xm">
                         {{ JSON.parse(scope.row.row_infos.append_infos) | jx_xm}}
                    </div>
                    <div v-else-if="val.is_lx">
                         {{ JSON.parse(scope.row.row_infos.append_infos) | jx_lx}}
                    </div>
                    <div v-else-if="val.is_hd">
                        {{'『中国原创壁纸设计大赛』-上线倒计时！'}}
                    </div>
                    <div v-else>
                    {{scope.row[val.prop]}}
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column
            v-for="(val,index) in tableTitle" :key="index"
            :prop="val.prop"
            :label="label.label"
            width="180">
            </el-table-column> -->
        </el-table>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            tableData:[],
            tableTitle:[
                {
                    prop:'work_id',
                    label:'作品ID'
                },
                {
                    prop:'work_name',
                    label:'作品名称'
                },
                {
                    prop:'activity_id',
                    label:'活动ID'
                },
                {
                    prop:'',
                    label:'活动名称',
                    is_hd:true
                },
                {
                    prop:'open_id',
                    label:'用户ID'
                },
                {
                    prop:'username',
                    label:'用户名称',
                    is_username:true
                },
                {
                    prop:'face_pic',
                    label:'作品封面图',
                    is_img:true
                },
                {
                    prop:'',
                    label:'姓名',
                    is_xm:true
                },
                {
                    prop:'',
                    label:'联系方式',
                    is_lx:true
                },
                {
                    prop:'pic_urls',
                    label:'内容图片地址',
                    is_img_url:true
                }
            ]
        }
    },
    filters: {
        jx_xm(val){
            if(val){
                return val[0].url
            }else{
                return '--'
            }
        },
        jx_lx(val){
            if(val){
                return val[1].url
            }else{
                return '--'
            }
        }
    },
    mounted(){
        this.get_api_Activity_work()
    },
    methods:{
        get_api_Activity_work(){
            axios({
                method:'get',
                url:`${window.file_baseURL}/Api/Activity/work`,
                // url:'https://shiquaner-api.zookingsoft.com/Api/Activity/work',
                params:{
                    activity_id:54,
                    all_info:1,
                    limit:999
                },
            }).then(res=>{
                console.log(res,'res')
                this.tableData = res.data.data.data
                console.log(this.tableData,'this.tableData')
                
            })
        }
    }
}
</script>

<style scoped>
.look_work_box{
    padding: 30px 0;
}
</style>